export default "__VITE_ASSET__BkBAu8nB__"